<div class="invoice-details-page">
    <div class="header-section">
        <div class="header">
            <h1 class="theme-heading">{{ 'InvoiceDetails' | translate }}</h1>
            <por-base-button [featureName]="'invoice-detail-close'" (click)="onCloseButtonClick()" icon="close"></por-base-button>
        </div>
    </div>
    <div class="content">
        <ng-container [ngTemplateOutlet]="id_consumer"></ng-container>
    </div>
</div>
<ng-template #id_consumer>
    <div>
        <ng-container [ngTemplateOutlet]="id_common_dates"></ng-container>
        <div class="detail">
            <ng-container [ngTemplateOutlet]="id_common_stats"></ng-container>
            <ng-container [ngTemplateOutlet]="id_common_btns"></ng-container>
        </div>
        <ng-container [ngTemplateOutlet]="id_common_line_item_table"></ng-container>
    </div>
</ng-template>
<ng-template #id_common_stats>
    <div class="stats">
        <p>
            <label porAddFeature featureName="invoice-detail-invoice-number">{{ 'invoiceNumber' | translate }}</label>
            <span>{{ invoiceDetail.Name }}</span>
        </p>
        <p>
            <label porAddFeature featureName="invoice-detail-type">{{ 'Type' | translate }}</label>
            <span>{{ invoiceDetail.Type }}</span>
        </p>
    </div>
</ng-template>
<ng-template #id_common_dates>
    <div class="dates">
        <div>
            @if (invoiceDetail.InvoiceDate) {
            <p>
                <label porAddFeature featureName="invoice-detail-invoice-date-label">{{ 'invoiceDate' | translate }} :</label>
                <span>{{ invoiceDetail.InvoiceDate | depotTimezoneDate : 'full' | async }}</span>
            </p>
            }
        </div>
    </div>
</ng-template>
<ng-template #id_common_btns>
    <div class="pay-btns">
        @if (featureToggleService.isAvailable('isInvoicePdfDisplayed')) {
        <span class="pdf-btn">
            @if (appFacadeService.isDocumentExists('Invoice') | async) {
            <por-base-button [loading]="(appFacadeService.isDocumentLoading('Invoice') | async) === true" porAddFeature [featureName]="'invoice-pdf-btn'" (click)="openDocumentUrl('Invoice')">
                <img class="actions-image" src="{{ uiUrl }}/assets/images/noun-pdf-file-5441350.svg" />
            </por-base-button>
            }
        </span>
        }
    </div>
</ng-template>
<ng-template #id_common_line_item_table>
    <div class="line-items-table">
        <table>
            <thead>
                <th class="text-center">{{ 'Site' | translate }}</th>
                <th class="text-center">{{ 'Document#' | translate }}</th>
                <th class="text-center">{{ 'Order#' | translate }}</th>
                <th class="text-center">{{ 'Item' | translate }}</th>
                <th class="text-center">{{ 'Start Date' | translate }}</th>
                <th class="text-center">{{ 'End Date' | translate }}</th>
                <th class="text-center">{{ 'cost' | translate }}</th>
            </thead>
            <tbody>
                @for (item of invoiceDetail.LineItems; track item) {
                <tr>
                    <td class="text-center">{{ invoiceDetail.AdditionalFields?.Address?.Name ?? '' }}</td>
                    <td class="text-center">{{ item.SourceDocNo }}</td>
                    <td class="text-center">{{ item.OrderNo }}</td>
                    <td class="text-center">{{ item.Name }}</td>
                    <td class="text-center">{{ item.StartDate | depotTimezoneDate : 'full' | async }}</td>
                    <td class="text-center">{{ item.EndDate | depotTimezoneDate : 'full' | async }}</td>
                    <td class="text-center">{{ item.LineTotal | formatCurrency }}</td>
                </tr>
                }
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="6" class="text-right">{{ 'netCharge' | translate }}</td>
                    <td class="text-center">
                        <strong>{{ (invoiceDetail.GrandTotal ?? 0) - (invoiceDetail.GrandTaxTotal ?? 0) | formatCurrency }}</strong>
                    </td>
                </tr>
                <tr>
                    <td colspan="6" class="text-right">{{ 'tax' | translate }}</td>
                    <td class="text-center">
                        <strong>{{ invoiceDetail.GrandTaxTotal | formatCurrency }}</strong>
                    </td>
                </tr>
                <tr>
                    <td colspan="6" class="text-right">{{ 'grossCharge' | translate }}</td>
                    <td class="text-center">
                        <strong>{{ invoiceDetail.GrandTotal | formatCurrency }}</strong>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</ng-template>
